import Vue from 'vue';
import Router from 'vue-router';
import store from './store';

Vue.use(Router);

const ifAuthenticated = (to, from, next) => {
  if (store.state.user === null || typeof store.state.user.token === 'undefined' || store.state.user.token === null || store.state.user.token === '') {
    next('/signin')
  }else{
    next()
  }
};

const ifAuthenticatedAdmin = (to, from, next) => {
  if (store.state.user === null || typeof store.state.user.token === 'undefined' || store.state.user.token === null || store.state.user.token === '') {
    next('/signin')
  }else if(store.state.user.userLevel == 60){
    next()
  }else{
    next('/signin')
  }
};

const ifAuthenticatedLf = (to, from, next) => {
  console.log('store.state',store.state)
  if (store.state.user === null || typeof store.state.user.token === 'undefined' || store.state.user.token === null || store.state.user.token === '') {
    next('/signin')
  }else if(store.state.user.userLevel == 80){
    next()
  }else{
    next('/signin')
  }
};

const ifAuthenticatedInSignin = (to, from, next) => {
  if (typeof store.state.user !== 'undefined' && store.state.user !== null && store.state.user !== '') {
    next('/form-list')
  }else{
    next()
  }
};

export default new Router({
  mode: 'history',
  routes: [
    { path: '*', component: () => import('@/views/ErrorScreen') }, 
    {
      path: '/',
      redirect: '/signin'
    },
    {
      path:'/signin',
      name:'signin',
      component: () => import('@/views/Signin'),
      beforeEnter: ifAuthenticatedInSignin
    },
    {
      path:'/signup/admin',
      name:'signup',
      component: () => import('@/views/SignupAdmin'),
      beforeEnter: ifAuthenticatedInSignin
    },
    {
      path:'/signup/staff/:formId?/:adminId?',
      name:'signup',
      component: () => import('@/views/SignupStaff'),
    },
    {
      path:'/wait-form',
      name:'waitForm',
      component: () => import('@/views/WaitForm')
    },
    {
      path:'/forgot-password',
      name:'Forgot Password',
      component: () => import('@/views/ForgotPassword')
    },
    {
      path:'/reset-password/:secret?',
      name:'Reset Password',
      component: () => import('@/views/ResetPassword')
    },
    {
      path:'/assign-form',
      name:'assignForm',
      beforeEnter:ifAuthenticatedLf,
      component: () => import('@/views/UserList')
    },
    {
      path:'/changelog',
      name:'Changelog',
      component: () => import('@/views/ChangeLog')
    },
    {
      path:'/form-list',
      name:'Form List',
      beforeEnter:ifAuthenticated,
      component: () => import('@/views/FormList')
    },
    {
      path:'/form-data-list/:formId/:roleId?',
      name:'Form Data List',
      props: (route) => ({ 
        routerData:route.query
      }),
      component: () => import('@/views/FormDataList')
    },
    {
      path:'/assign-theme/:userId?',
      name:'Assign Theme',
      component: () => import('@/views/AssignTheme')
    },
    {
      path:'/join-form/:formId/:adminId',
      name:'Join Form',
      component: () => import('@/views/JoinForm')
    },
    {
      path:'/edit-profile',
      name:'Edit profile',
      component: () => import('@/views/EditProfile')
    },
    {
      path:'/edit-user/:id',
      name:'Edit user',
      component: () => import('@/views/EditUser')
    },
    {
      path:'/manage-user',
      name:'Manage user',
      component: () => import('@/views/ManageUer')
    },
    {
      path:'/add-user',
      name:'Add user',
      component: () => import('@/views/AddUser')
    }
  ],
});